import { z } from "zod";

const FormFieldSchema = z.object({
  id: z.string().nullish(),
  ref: z.string().nullish(),
  type: z.string().nullish(),
  title: z.string().nullish(),
  properties: z.any(),
  choices: z
    .object({
      id: z.string().nullish(),
      label: z.string().nullish(),
    })
    .array(),
});

const OnboardingFormResponseSchema = z.object({
  form_id: z.string().nullish(),
  token: z.string().nullish(),
  landed_at: z.string().nullish(),
  submitted_at: z.string().nullish(),
  hidden: z.object({
    domain: z.string().nullish(),
    email: z.string().nullish(),
  }),
  definition: z.object({
    id: z.string().nullish(),
    title: z.string().nullish(),
    fields: FormFieldSchema.array().nullish(),
  }),
  answers: z
    .object({
      type: z.string().nullish(),
      choice: z.object({ label: z.string().nullish() }),
      field: z.object({
        id: z.string().nullish(),
        type: z.string().nullish(),
        ref: z.string().nullish(),
      }),
    })
    .array()
    .nullish(),
});

export type OnboardingFormResponseType = z.infer<
  typeof OnboardingFormResponseSchema
>;

export const OnboardingFullFormRequestBodySchema = z.object({
  event_id: z.string().nullish(),
  event_type: z.string().nullish(),
  form_response: OnboardingFormResponseSchema.nullable(),
});

export type OnboardingFullFormRequestBodyType = z.infer<
  typeof OnboardingFullFormRequestBodySchema
>;
